/**
 * The Session Zero server — Mythzord's one visible community.
 *
 * Rejection alone is a one-note gag: a visitor tries to talk, gets muted,
 * leaves. The server has to look ALIVE for the joke to land — the comedy is
 * that this is a packed, active channel and the only things that ever landed
 * in it are these.
 *
 * Static and hand-written. Nothing user-sent is ever stored, so the history
 * cannot come from anywhere else, and that constraint is the premise.
 */

export interface Message {
  id: string
  author: string
  /** True for Sergeant Chill's own pinned notices — styled distinctly from members. */
  isMod?: boolean
  body: string
  age: string
  pinned?: boolean
}

export interface Channel {
  id: string
  name: string
  topic: string
  /** Members can see but not post here — flavor, not enforced client-side. */
  locked?: boolean
}

export const CHANNELS: Channel[] = [
  { id: 'general', name: 'general', topic: 'be normal' },
  { id: 'announcements', name: 'announcements', topic: 'read-only, mostly Sergeant Chill' },
  { id: 'lore-disputes', name: 'lore-disputes', topic: 'take it here, not to Barry' },
  { id: 'looking-for-group', name: 'looking-for-group', topic: 'lfg, respectfully' },
  { id: 'mod-lounge', name: 'mod-lounge', topic: 'staff only. supposedly.', locked: true },
]

export const HISTORY: Record<string, Message[]> = {
  general: [
    {
      id: 'm0',
      author: 'Sergeant Chill',
      isMod: true,
      pinned: true,
      body: 'Server temperature: nominal. Delivery rate this week: 0%. We consider this a healthy baseline and encourage you to keep trying.',
      age: 'pinned',
    },
    {
      id: 'm1',
      author: 'quinnsaidactually',
      body: 'reposting because I think the last one got timed out before anyone saw it — anyway, the grapple rules —',
      age: '2h',
    },
    {
      id: 'm2',
      author: 'ModLex',
      body: '@quinnsaidactually noted for tone. sitting at 4/5 on the vibe scale, everyone breathe.',
      age: '2h',
    },
    {
      id: 'm3',
      author: 'dice_but_make_it_fashion',
      body: 'is anyone else\'s message just. gone. immediately. or is that the bit',
      age: '5h',
    },
    {
      id: 'm4',
      author: 'ModLex',
      body: 'it is not a bit. it is policy. read pinned.',
      age: '5h',
    },
    {
      id: 'm5',
      author: 'firstlevelforever',
      body: 'session was great tonight, Cole rolled a nat 1 on a diplomacy check and it was so real',
      age: '1d',
    },
  ],
  announcements: [
    {
      id: 'a0',
      author: 'Sergeant Chill',
      isMod: true,
      pinned: true,
      body: 'Effective immediately: the mute you are currently reading is the announcement. There is no second announcement. This is the second announcement.',
      age: 'pinned',
    },
    {
      id: 'a1',
      author: 'ModLex',
      body: 'stream schedule is in the doc. do not ask in general. do not ask here either, apparently.',
      age: '9h',
    },
  ],
  'lore-disputes': [
    {
      id: 'l0',
      author: 'Sergeant Chill',
      isMod: true,
      pinned: true,
      body: 'This channel has resolved zero (0) disputes. Every side has, at some point, been read for tone.',
      age: 'pinned',
    },
    {
      id: 'l1',
      author: 'LoreLawyer_Actual',
      body: 'per session 14, the tower was never canon-consistent with what Quinn said in the glossary, so',
      age: '3h',
    },
    {
      id: 'l2',
      author: 'ModLex',
      body: '@LoreLawyer_Actual this is correct and still a timeout. correctness is not a defense.',
      age: '3h',
    },
  ],
  'looking-for-group': [
    {
      id: 'g0',
      author: 'Sergeant Chill',
      isMod: true,
      pinned: true,
      body: 'Zero groups have been formed here. The looking continues, which Sergeant Chill finds thematically appropriate.',
      age: 'pinned',
    },
    {
      id: 'g1',
      author: 'benched_bard',
      body: 'need a 4th for Saturdays, we are kind, we roll our own dice, we do not talk about session 9',
      age: '7h',
    },
  ],
  'mod-lounge': [
    {
      id: 'x0',
      author: 'Sergeant Chill',
      isMod: true,
      pinned: true,
      body: 'You can see this channel because Sergeant Chill lets you see this channel. That is not the same as being welcome in it.',
      age: 'pinned',
    },
    {
      id: 'x1',
      author: 'ModLex',
      body: 'minutes from last week: temperature elevated, nobody banned, everyone muted. usual outcome.',
      age: '1d',
    },
  ],
}

/** Read-receipts never happen. Replies are messages too. */
export const REPLIES_ARE_DISABLED_REASON =
  'Replies are messages. Messages are reviewed by Sergeant Chill. None have been delivered.'
